import {useShortcut} from '@github-ui/code-view-shared/hooks/shortcuts'
import {useReposAnalytics} from '@github-ui/code-view-shared/hooks/use-repos-analytics'
import type React from 'react'

import {textAreaId} from '../../utilities/lines'
import {DuplicateOnKeydownButton} from '../DuplicateOnKeydownButton'

export function FindFilesShortcut({
  inputRef,
  onFindFilesShortcut,
}: {
  inputRef: React.RefObject<HTMLInputElement> | null
  onFindFilesShortcut?: () => void
}) {
  const {sendRepoKeyDownEvent} = useReposAnalytics()
  const {findFilesShortcut} = useShortcut()

  return (
    <DuplicateOnKeydownButton
      buttonFocusId={textAreaId}
      buttonHotkey={findFilesShortcut.hotkey}
      onButtonClick={() => {
        onFindFilesShortcut?.()
        inputRef?.current?.focus()
        sendRepoKeyDownEvent('GO_TO_FILE')
      }}
    />
  )
}

try{ FindFilesShortcut.displayName ||= 'FindFilesShortcut' } catch {}